import { useMemo } from 'react';

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';

import type { EpiMessage } from '../types/epi-chat-types';
import type { ReviewItem } from '../types/review-types';
import { getPendingReviewItems } from '../utils/reviewItems';

export interface UsePendingReviewItemsResult {
  /** Every item awaiting the researcher's answer (empty when the flag is off). */
  pendingItems: ReviewItem[];
  /** The items to put on screen now: none while the agent's turn is still running. */
  visibleItems: ReviewItem[];
}

/**
 * The Review card's items under ``research_assistant_review_card``. The card
 * waits for its turn to finish before appearing, because an answer sent while
 * the run is tearing down is rejected with RUN_IN_PROGRESS.
 * TODO: cleanup with research_assistant_review_card ff
 */
export const usePendingReviewItems = (
  messages: ReadonlyArray<EpiMessage>,
  agentRunning: boolean
): UsePendingReviewItemsResult => {
  const enabled = Boolean(useFeatureFlagSplit('research_assistant_review_card'));
  const pendingItems = useMemo(
    () => (enabled ? getPendingReviewItems(messages) : []),
    [enabled, messages]
  );
  return { pendingItems, visibleItems: agentRunning ? [] : pendingItems };
};
